<template>
  <div class="p-8">
    <el-form
      label-position="top"
      :model="assetTransferDetailsForm"
      ref="assetTransferDetailsForm"
      :rules="rules"
      label-width="80px"
      size="normal"
    >
      <p class="font-bold text-xs mb-2" id="bankDetails">Transfer Details</p>
      <hr />
      <el-form-item label="Asset" prop="asset">
        <el-select
          class="w-full"
          v-model="assetTransferDetailsForm.asset"
          placeholder="Select Asset"
        >
          <el-option
            v-for="asset in assetOptions"
            :key="asset"
            :label="asset"
            :value="asset"
          >
            {{ asset }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="Network" prop="network">
        <el-select
          class="w-full"
          v-model="assetTransferDetailsForm.network"
          placeholder="Network"
        >
          <el-option
            v-for="item in networkOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            {{ item.label }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="Recipient Wallet Address" prop="walletAddress">
        <el-input
          class="w-full"
          v-model="assetTransferDetailsForm.walletAddress"
          placeholder="Enter Wallet Address"
        ></el-input>
      </el-form-item>
      <hr />
      <el-form-item label="Reference" prop="reference">
        <el-input
          class="w-full"
          v-model="assetTransferDetailsForm.reference"
          placeholder="Enter Reference"
        ></el-input>
      </el-form-item>
      <o-button
        :loading="isLoading"
        @click="validateForm('assetTransferDetailsForm')"
        class="text-white"
      >
        {{ !isLoading ? 'Next' : 'Confirming....' }}</o-button
      >
    </el-form>
  </div>
</template>

<script>
import { ASSETS_NETWORKS } from '@/utils/constants.js'
import country from '@/mixins/getCountryDetails'
import localDeposit from '@/mixins/localDeposit.js'
import { ValidateWallet, GetCurrencyCountry } from '@/utils/helpers.js'

export default {
  name: 'RecipientInformation',
  mixins: [country, localDeposit],
  data () {
    return {
      networkOptions: ASSETS_NETWORKS,
      assetOptions: [],
      isLoading: false,
      isSearchableBankName: false,
      rules: {
        reference: [
          {
            required: true,
            message: 'Please enter reference',
            trigger: ['blur', 'change']
          }
        ],
        network: [
          {
            required: true,
            message: 'Please select a network',
            trigger: ['blur', 'change']
          }
        ],
        asset: [
          {
            message: 'Please select an asset',
            trigger: ['blur', 'change']
          }
        ],
        walletAddress: [
          {
            required: true,
            message: 'Please enter a valid wallet address',
            trigger: 'change'
          },
          {
            validator: this.validateWalletAddress,
            trigger: ['change']
          }
        ]
      },
      assetTransferDetailsForm: {
        asset: '',
        network: '',
        walletAddress: '',
        reference: ''
      }
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    validateForm (assetTransferDetailsForm) {
      this.isLoading = true
      this.$refs[assetTransferDetailsForm].validate((valid) => {
        if (valid) {
          this.$store.dispatch(
            'common/setSecondaryCountry',
            this.getCurrencyCountry(this.assetTransferDetailsForm.asset)
          )
          this.$store.dispatch(
            'terminal/setRecipientInformation',
            this.assetTransferDetailsForm
          )
          this.isLoading = false
          this.$emit('next')
        } else {
          this.isLoading = false
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    validateWalletAddress (rule, value, callback) {
      const validator = this.networkOptions.find(
        (network) => network.value === this.assetTransferDetailsForm.network
      ).validator
      const network = this.networkOptions.find(
        (network) => network.value === this.assetTransferDetailsForm.network
      ).shortName

      const isValid = ValidateWallet(value, network, validator)

      if (!isValid) {
        callback(new Error('Invalid Wallet Address'))
      } else {
        callback()
      }
    }
  },
  computed: {
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    }
  },
  mounted () {
    this.assetTransferDetailsForm.asset = this.country2.currency
  },
  async beforeMount () {
    this.assetOptions.push(this.country2.currency)
    // Prefill Recipient Information ; Functionaliy also to be extensible for prefilling BENEFICAIRY information
    if (this.recipientInfo && Object.keys(this.recipientInfo).length > 0) {
      this.assetTransferDetailsForm = this.recipientInfo
    }
  }
}
</script>

<style>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}

.btn {
  height: 4.375rem;
  border-radius: 200px;
}
</style>
